import React, { useContext, useEffect } from "react";
import StateContext from "../../context/state";
import styles from "./Pagination.module.scss";
import PathContext from "../../context/path";
const Pagination = () => {
  const path = useContext(PathContext);
  const stateApp = useContext(StateContext);
  const { stage, allStages, updateStage, transition, updateTransition, isMobile } = stateApp;

  const handleClick = (index) => {
    if (!transition) {
      updateStage(index);
      updateTransition(true);
    }
  }
  let dots = [];
  if (allStages !== undefined && allStages > 0 && stage !== undefined) {
    if (!isMobile) {
      for (let i = 0; i < allStages; i++) {
        if (i === stage) {
          dots.push(<div className={`${styles.dot} ${styles.active}`} key={`dot-${i}`}></div>)
        } else {
          dots.push(<div className={styles.dot} key={`dot-${i}`} onClick={() => { handleClick(i) }}></div>)
        }
      }
    } else {
      dots = `${stage + 1}/${allStages}`
    }
  }
  return (
    <>
      <div className={styles.wrap} data-pagination>
        {dots}
      </div>
    </>
  );

}

export default Pagination;
